<template>
  <color-span class="subtitle-wrapper" :border="color">
    <slot />
  </color-span>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: 'blue-400'
    }
  }
}
</script>

<style lang="less" scoped>
@import (reference) '~@/assets/less/main.less';

.subtitle-wrapper {
  display: block;
  color: @bluegrey-800;
  font-weight: 600;
  font-size: 15px;
  border-width: 2px;
  border-top: 0;
  border-left: 0;
  border-right: 0;
  padding-bottom: 8px;
}
</style>
